// import useDialog from './useDialog';

const useCertificateMessage = () => {
	// const { dialog } = useDialog();

	const redirect = (url: string) => {
		window.location.href = url;
	};

	// const openInstallPage = () => window.open('https://www.sberbank.com/ru/certificates');

	const getUrlAfterRedirect = async (func: () => any) => {
		const url = await func();
		if (url) {
			redirect(url);
		}
	};

	//  На платформе все функции оплаты проходят через хук onRedirect, я остановился на таком решении
	//  Мы оборачиваем в него все асинхорнные функции оплаты, т.е передаём в onRedirect оплату => onRedirect(наша async ф-ция)
	//  Лучше всего делать это внутри хука с оплатой, в return { onBuy: ()=> onRedirect(наша функция с оплатой)},
	//  так мы убираем лишьний код из ui и не забиваем лишней логикой саму ф-цию оплаты

	const onRedirect = async (func: () => any) => {
		getUrlAfterRedirect(func);
		// dialog({
		// 	title: 'Обратите внимание',
		// 	text: 'Для стабильной работы оплаты в платежной системе Сбербанк требуются сертификаты минцифры. Открыть инструкцию для установки? \n Если в Вашей системе уже установлены необходимые сертификаты, Вы можете продолжить оплату',
		// 	closeToConfirm: false,
		// 	onRequestClose: true,
		// 	dinamicHeight: false,
		// 	confirm: () => openInstallPage(),
		// 	decline: () => getUrlAfterRedirect(func),
		// 	confirmText: 'Открыть инструкцию',
		// 	declineText: 'Продолжить оплату',
		// });
	};

	return {
		onRedirect,
	};
};

export default useCertificateMessage;
